import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const personalSectionComponent = {
  editLink: 'personal-section.edit-link',
  email: 'personal-section.email',
  firstName: 'personal-section.first-name',
  h3: 'personal-section.h3',
  lastName: 'personal-section.last-name',
  phoneNumber: 'personal-section.phone-number',
  root: 'personal-section.root',
} as const satisfies ComponentLocatorMap;
